import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BACKGROUNDIMAGE } from 'src/app/app.config';
import { Hotel, Usuario } from 'src/app/model';
import { HotelService } from 'src/app/services';

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrls: ['./hotel.component.scss'],
  standalone: false
})
export class HotelComponent implements OnInit {
  @Input() hotel: Hotel;
  @Input() usuario: Usuario;
  @Input() carregando: boolean = false;
  @Input() politicaListagem: {hotelId: number, agenciaId: number, guid: string, listagem: boolean} = { hotelId: 0, agenciaId: 0, guid: "", listagem: false };
  @Output() selecionouHotel = new EventEmitter<Hotel>();
  @Output() removeuHotel = new EventEmitter<Hotel>();
  @Output() rebuscar = new EventEmitter<any>();
  backgroundimage = BACKGROUNDIMAGE;

  constructor(
    private hotelService: HotelService,
    private ngbModal: NgbModal,
    public router: Router
  ) { }

  ngOnInit() {
  }

  selecionou(hotel: any) {
    this.selecionouHotel.emit(hotel);
  }

  removeu(hotel: any) {
    this.removeuHotel.emit(hotel);
  }

  removerHotel(hotel) {
    if (confirm('Deseja Remover o Hotel?')) {
      this.removeu(hotel);
    }
  }

  abrirModal(content) {
    this.ngbModal.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'xl' })
  }

  somaTotal(arr) {
    return arr
      .map(x => x.ValorListagem)
      .reduce(function (a: any, b: any) {
        return a + b;
      }, 0);
  }

  GetHotelDetalhes() {
    // this.carregando = true;
    this.hotelService.detalhesHotel(this.hotel).subscribe(
      dados => {
        this.hotel = dados;
        // this.carregando = false;
      }, erro => {
        // this.carregando = false;
      });
  }
}
